// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"sq-z","selected":"tq-z"};